
export const API_SERVER = 'http://localhost:4000/api/v1'
export const WEBHOOK_SERVER = 'http://emi-motion-staging.us-east-1.elasticbeanstalk.com'
export const ROLE_EMPLOYEE = "ROLE_EMPLOYEE"
export const TRACKING_ENABELD = false
